import React, { Component } from 'react';

import ApplyContainer from './ApplyContainer';

const NycApply = props => <ApplyContainer {...props} />;

export default NycApply;



// WEBPACK FOOTER //
// ./src/components/NycApply/index.js